module.exports = __webpack_public_path__ + "static/media/calendar.786349b3.svg";